import React, { useState } from "react";
import { HOME, type HomeState } from "@/shared/constants/home";
import LoaderDots from "../LoaderDots";
import Locked from "../Locked";

function PlayButton({ kind, text, setHomeState } : { kind: string, text: string, setHomeState: (state: HomeState) => void }){
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (kind !== HOME.FC && kind !== HOME.NP && kind !== HOME.NONE) return;

    setLoading(true);
    setTimeout(() => setLoading(false), 1000);
    setTimeout(() => setHomeState(kind), 1000);
  };

    return(
            <button data-cy={`${kind}-btn`} className={kind} onClick={handleClick}>
              {loading ? (
                <LoaderDots/>
              ) : (
                <>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" style={{ paddingTop: "2px" }} width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="12" r="10"/>
                      <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"/>
                      <path d="M12 18V6"/>
                    </svg>
                  </span>
                  {text}
                  {kind === HOME.NP && (
                    <Locked home={true}/>
                  )}
                </>
              )}
            </button>
    )
}

export default PlayButton
